import { toast } from "react-toastify";
import { GET_ALL_USER_NOTIFICATIONS, ADD_NEW_LIVE_NOTIFICATION, GET_USER_ALL_NOTIFICATIONS } from "./notificationTypes";
import { check_token_expired_logout } from "../user/userAction";
import apiClient from "../../api/apiClient";

// get admin notifications 
export const get_user_all_notifications = async (dispatch, batchTranslate, language, page, limit) => {
  try {
    let urlPath = `admin/notifications`;
    if (page) urlPath += `?&page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {

      let updatedNotifications = res?.data?.notifications;
      
      if (language === 'nl') {
        updatedNotifications = await batchTranslate(updatedNotifications, [
          "notification_title",
          "notification_message",
          "notification_type"
        ], language);
      }

      const updatedData = { ...res?.data };
      updatedData.notifications = updatedNotifications;

      dispatch({ type: GET_USER_ALL_NOTIFICATIONS, payload: updatedData });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// read notification function 
export const user_read_notifications = async (dispatch, id, status) => {
  try {
    const urlPath = `admin/mark-seen?id=${id}&status=${status}`;
    const res = await apiClient.patch(urlPath);
    if (res.data && res.data.status) {
      return true;
    }
    else {
      toast.error(res.data.message);
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// mark all read function 
export const user_all_read_notifications = async (dispatch, status) => {
  try {
    const urlPath = `admin/mark-seen?status=${status}`;
    const res = await apiClient.patch(urlPath);
    if (res.data && res.data.status) {
      return true;
    }
    else {
      toast.error(res.data.message);
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const addNewLiveNotification = (notificationData) => {
  return {
    type: ADD_NEW_LIVE_NOTIFICATION,
    payload: notificationData
  };
};